import { LogEntry } from './log-entry.model';
import { LogPublisher } from './log-publisher';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

export class LogToWebApi extends LogPublisher {
    apiUrl = 'https://3ca52d5a-9607-4e9f-8513-e717b244e4c4.mock.pstmn.io/log'; //TODO config

    constructor(private _http: HttpClient) {
        super();
    }

    override log(entry: LogEntry): void {
        const headers = new HttpHeaders().set('content-type', 'application/json');
        this._http.post<LogEntry>(this.apiUrl, JSON.stringify(entry), { headers: headers });//.pipe(catchError(this.handleErrors)
        // TODO: Call Web API to send logs
    }


    override clear(): void {}
}
